import Vue from 'vue';
import axios from 'axios';

// axios.defaults.baseURL = process.env.VUE_APP_API_URL;
// axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
// axios.defaults.withCredentials = true;

// Vue.prototype.$http = axios;
let api = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
    crossdomain: true
  }
})

api.interceptors.response.use(response => response , (error) => {
  console.log('error from the interceptor: ')
  console.error(error)
})

Vue.prototype.$http = api;
